import DOMPurify from "dompurify";
import CustomWebHaptics from "../utils/webHaptics";
export class HtmxControls {
    options;
    webHaptics = new CustomWebHaptics();
    constructor(options) {
        this.options = options;
    }
    render() {
        if (!this.options) {
            throw new Error("At least one HTMX options must be selected. Now quitting...");
        }
        const { hxget, hxtrigger, hxswap, hxpushurl } = this.options;
        const base = `
            hx-get="${hxget}"
            hx-trigger="${hxtrigger}"
            hx-swap="${hxswap}"
            hx-push-url="${hxpushurl}"
        `;
        const sanitizedHTML = DOMPurify.sanitize(base);
        return sanitizedHTML.trim();
    }
}
